import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import CompanyService from 'services/company2';
import CustFieldService from 'services/custField';
import * as MobileActions from 'actions/index.ts';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import User from 'services/user2';
import ModalService from 'services/modal';
import Http from 'services/http2';
import CommonFns from 'functions/common.ts';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import DeliveryFns from 'functions/delivery.ts';
import EditIcon from '@material-ui/icons/Edit';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import ReceiveService from 'services/receive.ts';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Enum from 'services/enum2';
import { withStyles } from '@material-ui/core/styles';
import Big from 'big.js';
const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw'
  },
  marginNormal: {
    marginTop: '0px'
  },
  input: {
    padding: '10px 20px'
  }
});
const isEmpty = Util.isEmpty;
function CustomerReceiveAsnDetail(props) {
  const Config = {
    sale: {
      apiPath: '/signforOrder/getDetail',
      enumMainKey: 'B02_Dn_Sign_For_Status',
      companyNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Purchase_Type',
          subKey: 'purchaseType',
          value: 'purchaseTypeName'
        },
        {
          mainKey: 'B02_Dn_Logistics_Status',
          subKey: 'logisticsStatus',
          value: 'logisticsStatusName'
        },
        {
          mainKey: 'B02_Dn_Type',
          subKey: 'deliveryType',
          value: 'deliveryTypeName'
        },
        {
          mainKey: 'B02_Dn_Sign_For_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'dnXkNo'
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    forceUpdate,
    detail,
    setDetail,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [fieldSetting, setFieldSetting] = useState({});
  const [lineList, setLineList] = useState([]);
  const [currItem, setCurrItem] = useState({
    receiveQty: '',
    receiveValuationQty: ''
  });
  const [receiveQtyEdit, setReceiveQtyEdit] = useState(false);
  const [ruleVersionList, setRuleVersionList] = useState([]);
  const [isSetBarcode, setIsSetBarcode] = useState(false);
  const [showVerifyStatus, setShowVerifyStatus] = useState(true);

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);
  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  useEffect(() => {
    detail.deliveryCarNo = detail.deliveryCarNo || '';
    detail.contactPersion = detail.contactPersion || '';
    detail.contactMobile = detail.contactMobile || '';
    detail.addressInfo = detail.addressInfo || '';
    detail.receiveContactPerson = detail.receiveContactPerson || '';
    detail.receiveContactWay = detail.receiveContactWay || '';
    detail.logisticsNumber = detail.logisticsNumber || '';
  }, [detail]);

  self.afterGetDetail = function (data) {
    let list = data.lineList || [];
    setLineList(DeliveryFns.parseLineList(list));
    //获取企业参数-是否启用平台收货流程
    CompanyService.getCompanyParamsByCodes(
      [companyCode],
      [
        'Use_platform_recieve_process',
        'Use_platform_verify_process',
        'Use_recieve_order_down_erp'
      ],
      true
    ).then(res => {
      let companyParams = {};
      res.forEach(row => {
        companyParams[row.paramCode] =
          row.paramType === 1 ? row.paramValue : row.paramValue === '1';
      });
      let recieveProcess = companyParams['Use_platform_recieve_process'];
      let verifyProcess = companyParams['Use_platform_verify_process'];
      let recieveDownErp = companyParams['Use_recieve_order_down_erp'];

      /*
       * 是否展示检验相关字段。启用平台收货流程，下传ERP是收货单、且开启来料检验,不展示检验相关字段
       */
      setShowVerifyStatus(
        !(recieveProcess && recieveDownErp === '1' && verifyProcess)
      );

      list.forEach(item => {
        if (
          recieveProcess &&
          recieveDownErp === '2' &&
          verifyProcess &&
          Util.isBig(
            item.totAllowQty,
            item.totCompromiseQty,
            item.convertReceiveQty
          ) &&
          !Big(item.totAllowQty)
            .plus(item.totCompromiseQty)
            .minus(item.convertReceiveQty)
            .gt(0)
        ) {
          item.canGodown = false;
        } else {
          item.canGodown = true;
        }
        Enum.getValue('B02_Send_Verify_Status', item.sendVerifyStatus).then(
          value => {
            item.sendVerifyStatusName = value;
            forceUpdate();
          }
        );
        //1.订单，2.排程
        Enum.getValue('B02_Bill_type', item.billType).then(value => {
          item.billTypeName = value;
          forceUpdate();
        });
      });
      if (!self.isPurchase) {
        checkDeliveryValuationQty(list, data);
      }
    });

    //预设值
    ['extendN01Value', 'extendN02Value', 'extendN03Value'].forEach(key => {
      let o = Util.jsonDecode(data[key]);
      if (Array.isArray(o)) {
        if (typeof o[0] === 'string') {
          data[key] = (o || []).map(value => {
            return {
              id: value,
              text: value
            };
          });
        } else {
          data[key] = o;
        }
      }
    });
    //按钮显示条件
    getRuleDetail(data);
    getFieldSetting(data);
    getCustomerDetail(data);
    setDetail(data);
  };

  //获取自定义字段设置
  function getFieldSetting(data) {
    let customerCode;
    if (!self.isPurchase) {
      customerCode = data.customerCode;
    }

    //获取自定义字段
    CustFieldService.getSetting(
      companyCode,
      customerCode,
      true,
      22,
      dispatch
    ).then(rs => {
      if (rs) {
        let fieldData = rs;
        if (Array.isArray(fieldData.list)) {
          fieldData.list.forEach(item => {
            //单头单身日期字段，转换为时间戳
            CustFieldService.parseCustFields(
              fieldData,
              data,
              data.lineList,
              self.isPurchase
            );
          });
        }
        setFieldSetting(fieldData);
      }
    });
  }

  //修改送货数量
  function handleEdit(item, type) {
    setCurrItem(item);
    setReceiveQtyEdit(true);
  }

  //获取物料是否能维护计价数量的权限
  async function checkValuationQty(customerCode, productCodes) {
    let postbody = {
      companyCode: companyCode,
      customerCode,
      productCodes,
      apiPath: '/archives/customizeCategory/checkValuationQtyFlag'
    };
    let res = {};
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        res = response.data;
      }
    });
    return res;
  }

  async function checkDeliveryValuationQty(list, detailData) {
    if (self.isPurchase) {
      return;
    }
    let lineListArr = list || [];
    await checkValuationQty(
      detailData.customerCode,
      lineListArr.map(item => item.productCode)
    ).then(res => {
      for (const key in res) {
        if (Object.prototype.hasOwnProperty.call(res, key)) {
          lineListArr
            .filter(item => item.productCode === key)
            .forEach(item => {
              item.isEditDeliveryValuationQty = res[key] === 1 ? true : false;
            });
        }
      }
    });
  }

  function handleOrder(type) {
    const dnXkNo = detail.dnXkNo;
    switch (type) {
      case 'publish': //确认发出签收信息
        handleConfirm(
          dnXkNo,
          '/signforOrder/signForDnPublish',
          '确认发出签收信息？'
        );
        break;
      default:
    }
  }

  function handle(type) {
    handleOrder(type);
  }

  //发布发货通知
  function handleConfirm(dnXkNo, apiPath, dialogMsg) {
    let postbody = {
      companyCode: companyCode,
      dnXkNo,
      apiPath: apiPath
    };
    ReceiveService.deliveryConfirm(
      postbody,
      dialogMsg,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  function handleChange(event) {
    let { name, value } = event.target;
    currItem[value] = Util.qtyChange(currItem[value], false);
    setCurrItem(Object.assign({}, currItem, { [name]: value }));
  }

  function handleBlur(event, key) {
    let detailObj = Util.clone(detail);
    let val = event.target.value;
    setDetail(detailObj);
  }

  function handleClose() {
    setReceiveQtyEdit(false);
  }

  // 保存物料详情
  function handleOk() {
    if (!validate()) {
      return;
    }
    let arr = [];
    arr.push({
      lineNo: currItem.lineNo,
      receiveQty: currItem.receiveQty,
      receiveValuationQty: currItem.receiveValuationQty
    });
    let postbody = {
      companyCode: companyCode,
      lineList: arr,
      dnXkNo: self.id,
      apiPath: '/signforOrder/signForDnUpdateQty'
    };
    setShowLoading(true);
    Http.post('/api/cloudCenter', postbody).then(response => {
      setShowLoading(false);
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
      handleClose();
    });
  }

  //校验
  function validate() {
    let rs = true;
    if (currItem.receiveQty === '') {
      //签收数量不能为空
      ModalService.showError('签收数量不能为空', dispatch);
      return false;
    }
    if (currItem.receiveValuationQty === '') {
      //签收计价数量不能为空
      ModalService.showError('签收计价数量不能为空', dispatch);
      return false;
    }
    return rs;
  }

  //已有的条码规则
  function getRuleDetail(data) {
    data.ruleSettingType = '1'; //客户设置条码规则方式。1. 按供应商，2. 按物料分类。
    let arr = CompanyService.getCompanyParamsByCodes(
      data.customerCode,
      ['Delivery_Bar_Code_Rule_Settings'],
      true
    );
    if (Array.isArray(arr)) {
      data.ruleSettingType = arr[0]?.paramValue || '1';
    }

    //只有【未发送，撤回，退回】才可以重新修改送货单，需要重新获取条码规则列表
    if (data.status && ![0, 4, 6].includes(data.status)) {
      return;
    }

    if (data.ruleSettingType === '2') {
      data['ruleVersionCode'] = undefined;
      data['ruleVersionName'] = undefined;
      setRuleVersionList([]);
      return;
    }

    CompanyService.getCustomerRuleList(data.customerXkUniqueCode).then(res => {
      let list = res.map(item => {
        return { id: item.ruleVersionCode, text: item.ruleVersionName };
      });
      setRuleVersionList(list);
    });
  }

  function getCustomerDetail(data) {
    CompanyService.getCustomerDetail(
      companyCode,
      data.customerXkUniqueCode
    ).then(rs => {
      setIsSetBarcode(rs?.barcodeDeliveryRulesFlag === 1); //送货条码标识：0:不启用 1:启用
    });
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">客户</span>
                  <div className="field-value">{detail.innerCustomerName}</div>
                </li>
                <li>
                  <span className="field-label">送货日期</span>
                  <div className="field-value">
                    {formatDate(detail.deliveryDate)}
                  </div>
                </li>
                <li>
                  <span className="field-label">条码版本</span>
                  <div className="field-value">
                    <span>{detail.ruleVersionName}</span>
                  </div>
                </li>
                <li>
                  <span className="field-label">预计到厂</span>
                  <div className="field-value">
                    <div>
                      {formatDate(detail.planArrivedDate, 'YYYY-MM-DD HH:mm')}
                    </div>
                  </div>
                </li>
                <li>
                  <span className="field-label">送货状态</span>
                  <div className="field-value">
                    <span
                      className={
                        [1].indexOf(detail.status) > -1
                          ? 'green'
                          : [0].indexOf(detail.status) > -1
                          ? 'orange'
                          : ''
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                {detail.status === 6 && (
                  <li>
                    <span className="field-label">退回原因</span>
                    <div className="field-value">{detail.backReason}</div>
                  </li>
                )}
                {[4, 11].includes(detail.status) && (
                  <li>
                    <span className="field-label">撤回原因</span>
                    <div className="field-value">{detail.backReason}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">物流状态</span>
                  <div className="field-value">
                    <span
                      className={
                        [2].indexOf(detail.logisticsStatus) > -1
                          ? 'green'
                          : 'blue'
                      }
                    >
                      {detail.logisticsStatusName}
                    </span>
                  </div>
                </li>
                {self.isPurchase && showVerifyStatus && (
                  <li>
                    <span className="field-label">送检状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Send_Verify_Status',
                            detail.sendVerifyStatus
                          )
                        }
                      >
                        {detail.sendVerifyStatusName}
                      </span>
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">代收单号</span>
                  <div className="field-value">{detail.dnXkNo}</div>
                </li>
                <li>
                  <span className="field-label">送货单号</span>
                  <div className="field-value">{detail.sourceDnXkNo}</div>
                </li>
                {self.isPurchase ? (
                  ''
                ) : (
                  <li>
                    <span className="field-label">内部单号</span>
                    <div className="field-value">{detail.dnInnerNo}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">送货类型</span>
                  <div className="field-value">{detail.deliveryTypeName}</div>
                </li>
                <li>
                  <span className="field-label">采购类型</span>
                  <div className="field-value">{detail.purchaseTypeName}</div>
                </li>
                {detail.purchaseType === 3 && (
                  <li>
                    <span className="field-label">收货企业</span>
                    <div className="field-value">
                      {!self.isPurchase
                        ? detail.receiveCustomerInnerName
                        : detail.multiRelationRoleType === 1
                        ? detail.companyName
                        : detail.multiCompanyName}
                    </div>
                  </li>
                )}
                {!self.isPurchase && detail.profitCenterCode && (
                  <li>
                    <span className="field-label">收货部门</span>
                    <div className="field-value">{detail.profitCenterName}</div>
                  </li>
                )}

                {!self.isPurchase &&
                  fieldSetting.headCustList &&
                  fieldSetting.headCustList.map((item, index) => (
                    <li key={item.id}>
                      <span className="field-label">{item.transName}</span>
                      <div className="field-value">
                        {detail[item.fieldCode]}
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>物流信息{receiveQtyEdit}</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">送货方式</span>
                  <div className="field-value">{detail.logisticsTypeShow}</div>
                </li>
                <li>
                  <span className="field-label">
                    {detail.logisticsType === 3 ? '自提地址' : '送货地址'}
                  </span>
                  <div className="field-value">{detail.addressInfo}</div>
                </li>
                <li>
                  <span className="field-label">运输方式</span>
                  <div className="field-value">{detail.transportTypeName}</div>
                </li>
                {detail.logisticsType === 2 && (
                  <li>
                    <span className="field-label">物流单号</span>
                    <div className="field-value">{detail.logisticsNumber}</div>
                  </li>
                )}
                {[1, 5].includes(detail.logisticsType) && (
                  <li>
                    <span className="field-label">送货联络</span>
                    <div className="field-value">
                      {detail.contactPersion} {detail.contactMobile}
                    </div>
                  </li>
                )}
                {[1, 5].includes(detail.logisticsType) && (
                  <li>
                    <span className="field-label">送货车牌</span>
                    <div className="field-value">{detail.deliveryCarNo}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">联系方式</span>
                  <div className="field-value">
                    {detail.receiveContactPerson} {detail.receiveContactWay}
                  </div>
                </li>
                <li>
                  <span className="field-label">送货备注</span>
                  <div className="field-value">{detail.remark}</div>
                </li>
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign2 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(2);
            }}
          >
            {moreSign2 && '更多'}
            {!moreSign2 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>产品明细</label>
          </div>
          <div className="details-item-content">
            {!Util.isEmpty(lineList) &&
              lineList.map((line, index) => (
                <div
                  className="content-line line-list-item"
                  key={String(line[0].id) + index}
                >
                  <div className="line-list-item-title">
                    <span>序号{index + 1}</span>
                    {!self.isPurchase &&
                      User.checkAuth('20031302') &&
                      line.isSingle &&
                      [0, 4, 6].includes(detail.status) && (
                        <div className="more">
                          <i
                            className="icon-edit"
                            onClick={() => {
                              handleEdit(line[0], 1);
                            }}
                          ></i>
                        </div>
                      )}
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">产品编码</span>
                      <div className="field-value">{line[0].productCode}</div>
                    </li>
                    <li>
                      <span className="field-label">产品名称</span>
                      <div className="field-value">{line[0].productName}</div>
                    </li>
                    <li>
                      <span className="field-label">产品规格</span>
                      <div className="field-value">{line[0].productScale}</div>
                    </li>
                    <li>
                      <span className="field-label">客户单号(项次)</span>
                      <div className="field-value">
                        {line[0].poErpNo}({line[0].poLineNo})
                      </div>
                    </li>
                    <li>
                      <span className="field-label">送货类型</span>
                      <div className="field-value">{line[0].billTypeName}</div>
                    </li>
                    <li>
                      <span className="field-label">订单交期</span>
                      <div className="field-value">
                        {formatDate(line[0].expectedDate)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">
                        {self.isPurchase ? '订单应出数量' : '订单待交数量'}
                      </span>
                      <div className="field-value">
                        {formatNumber(
                          line[0].billType === 1
                            ? line[0].totalWaitDeliveryQty
                            : line.waitDeliveryQty,
                          decimalPlace.Quantity_Decimal_Place
                        )}
                      </div>
                    </li>
                    {line.isSingle && (
                      <li>
                        <span className="field-label">排定交期</span>
                        <div className="field-value">
                          {formatDate(line[0].deliveryDate)}
                        </div>
                      </li>
                    )}
                    {line.isSingle && (
                      <li>
                        <span className="field-label">
                          {self.isPurchase ? '排定应出数量' : '排定待交数量'}
                        </span>
                        <div className="field-value">
                          {formatNumber(
                            line[0].waitDeliveryQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                        </div>
                      </li>
                    )}
                    {detail.deliveryApplyFlag === 1 && (
                      <li>
                        <span className="field-label">申请数量</span>
                        <div className="field-value">
                          <span>
                            {formatNumber(
                              line.applyDeliveryQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                            {line[0].deliveryUnitName}
                          </span>
                        </div>
                      </li>
                    )}
                    <li>
                      <span className="field-label">实际送货数量</span>
                      <div className="field-value">
                        <span
                          className={
                            line.waitDeliveryQty !== line.deliveryQty
                              ? 'red'
                              : ''
                          }
                        >
                          {formatNumber(
                            line.deliveryQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                          {line[0].deliveryUnitName}
                        </span>
                      </div>
                    </li>
                    {detail.deliveryApplyFlag === 1 && (
                      <li>
                        <span className="field-label">申请计价数量</span>
                        <div className="field-value">
                          <span>
                            {formatNumber(
                              line.applyDeliveryValuationQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                            {line[0].valuationUnitName}
                          </span>
                        </div>
                      </li>
                    )}
                    <li>
                      <span className="field-label">计价数量</span>
                      <div className="field-value">
                        <span>
                          {formatNumber(
                            line.deliveryValuationQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                          {line[0].valuationUnitName}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">签收数量</span>
                      <div className="field-value">
                        <span>
                          {formatNumber(
                            line[0].receiveQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">签收计价数量</span>
                      <div className="field-value">
                        <span>
                          {formatNumber(
                            line[0].receiveValuationQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">备注</span>
                      <div className="field-value">{line[0].remark}</div>
                    </li>
                    <li>
                      <span className="field-label">订单备注</span>
                      <div className="field-value">
                        {line[0].srcOrderLineRemark}
                      </div>
                    </li>
                    {line[0].poLine &&
                      line[0].poLine.printExtendFields !== '' && (
                        <li>
                          <span className="field-label">采购说明</span>
                          <div className="field-value">
                            {line[0].poLine.printExtendFields}
                          </div>
                        </li>
                      )}
                    {fieldSetting.showBodyCol3 &&
                      fieldSetting.bodyCustList &&
                      fieldSetting.bodyCustList.map((item, i) => (
                        <li key={String(item.id) + i}>
                          <span className="field-label">{item.transName}</span>
                          <div className="field-value">
                            {line[0][item.fieldCode]}
                          </div>
                        </li>
                      ))}
                  </ul>
                  {line.isSingle ? (
                    ''
                  ) : (
                    <div className="order-detail-more">
                      {!line.isSingle &&
                        line.map((item, i) => (
                          <ul key={'sub' + item.id + i} className="field-list">
                            {!self.isPurchase &&
                              User.checkAuth('20030102') &&
                              !line.isSingle &&
                              [0].includes(detail.status) && (
                                <div className="order-detail-item">
                                  <span
                                    className="icons bc-wathet"
                                    style={{ top: '5px' }}
                                  >
                                    <EditIcon
                                      className="edit"
                                      onClick={() => handleEdit(line[i], 1)}
                                    />
                                    {!self.isPurchase && (
                                      <HighlightOffIcon
                                        className="delete"
                                        onClick={() => handleEdit(line[i], 2)}
                                      />
                                    )}
                                  </span>
                                </div>
                              )}
                            <li>
                              <span className="field-label">排定待交数量</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.waitDeliveryQty,
                                  decimalPlace.Quantity_Decimal_Place
                                )}
                                {item.deliveryUnitName}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">排定交期</span>
                              <div className="field-value">
                                {formatDate(item.deliveryDate)}
                              </div>
                            </li>
                            {detail.deliveryApplyFlag === 1 && (
                              <li>
                                <span className="field-label">申请数量</span>
                                <div className="field-value">
                                  <span>
                                    {formatNumber(
                                      item.applyDeliveryQty,
                                      decimalPlace.Quantity_Decimal_Place
                                    )}
                                    {item.deliveryUnitName}
                                  </span>
                                </div>
                              </li>
                            )}
                            <li>
                              <span className="field-label">实际送货数量</span>
                              <div className="field-value">
                                <span
                                  className={
                                    item.waitDeliveryQty !== item.deliveryQty
                                      ? 'red'
                                      : ''
                                  }
                                >
                                  {formatNumber(
                                    item.deliveryQty,
                                    decimalPlace.Quantity_Decimal_Place
                                  )}
                                  {item.deliveryUnitName}
                                </span>
                              </div>
                            </li>
                            {detail.deliveryApplyFlag === 1 && (
                              <li>
                                <span className="field-label">
                                  申请计价数量
                                </span>
                                <div className="field-value">
                                  <span>
                                    {formatNumber(
                                      item.applyDeliveryValuationQty,
                                      decimalPlace.Quantity_Decimal_Place
                                    )}
                                    {item.valuationUnitName}
                                  </span>
                                </div>
                              </li>
                            )}
                            <li>
                              <span className="field-label">计价数量</span>
                              <div className="field-value">
                                {' '}
                                <span>
                                  {formatNumber(
                                    item.deliveryValuationQty,
                                    decimalPlace.Quantity_Decimal_Place
                                  )}
                                  {item.valuationUnitName}
                                </span>
                              </div>
                            </li>
                          </ul>
                        ))}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="wrap m-flex-box fixed-bottom">
        {!self.isPurchase &&
          User.checkAuth('20030102') &&
          [0].includes(detail.status) &&
          (detail.deliveryApplyFlag === 0 || detail.deliveryType === 2) && (
            <Button
              type="default"
              onClick={() => {
                handle('publish');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认发出
            </Button>
          )}
      </div>
      {/* 编辑产品明细 */}
      {!self.isPurchase && [0].includes(detail.status) && (
        <Dialog
          anchor="bottom"
          open={receiveQtyEdit}
          classes={{ paper: props.classes.paper }}
          onClose={() => setReceiveQtyEdit(false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">编辑产品明细</DialogTitle>
          <DialogContent>
            <ul>
              <li className="dialog order-detail-item">
                <div className="line">
                  <span>项次：</span>
                  <div>{currItem.lineNo}</div>
                </div>
                <div className="line">
                  <span>物料编码：</span>
                  <div>{currItem.productCode}</div>
                </div>
                <div className="line">
                  <span>物料名称：</span>
                  <div>{currItem.productName}</div>
                </div>
                <div className="line">
                  <span>物料规格：</span>
                  <div>{currItem.productScale}</div>
                </div>
                <div className="line">
                  <span>客户单号：</span>
                  <div>
                    {currItem.poErpNo}({currItem.poLineNo})
                  </div>
                </div>
                <div className="line">
                  <span>签收数量：</span>
                  <div>
                    {
                      <input
                        type="text"
                        name="receiveQty"
                        value={currItem.receiveQty}
                        onChange={handleChange}
                      />
                    }
                  </div>
                </div>
                <div className="line">
                  <span>签收计价数量：</span>
                  <div>
                    {
                      <div>
                        <input
                          type="text"
                          name="receiveValuationQty"
                          value={currItem.receiveValuationQty}
                          onChange={handleChange}
                        />
                      </div>
                    }
                  </div>
                </div>
              </li>
            </ul>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleClose()}
              color="default"
              className="m-flex-item u-btn u-btn_primary"
            >
              取消
            </Button>

            <Button
              onClick={() => handleOk()}
              color="default"
              className="m-flex-item u-btn u-btn_primary"
            >
              确定
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Modal></Modal>
    </div>
  );
}

CustomerReceiveAsnDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CustomerReceiveAsnDetail));
